export default {
  'page-title': 'Creative Return Merchandize Authorization (RMA) System - Creative Labs (Japan) ',
  'page-desc': 'Check the status of your return request with your RMA number. ',
  'mode-of-contact': 'ご連絡方法',
  'your-details': 'お客様について',
  'rma-request': 'RMAリクエスト',
  'first-name': '姓',
  'last-name': '名',
  'enter-first-name': '姓をご入力ください。',
  'enter-last-name': '名をご入力ください。',
  'email-address': 'Eメールアドレス',
  'enter-email': 'Eメールアドレスをご入力ください。',
  'enter-valid-email': 'Eメールアドレスが正しい形式で入力されているかをご確認ください。',
  'enter-pid': 'Please enter your personal ID',
  'super-x-fi': 'Super X-Fi',
  'products': '製品',
  'sale': 'セール',
  'help': 'ヘルプ',
  'sign-in': 'ログイン',
  'account': 'アカウント',
  'loading-page': '読み込み中',
  'orders': 'ご注文',
  'membership-program': 'メンバーシップ プログラム',
  'account-profile': 'アカウント情報',
  'contact-us': 'お問い合わせ',
  'sign-out': 'ログアウト',
  'recent-orders': '最近のご注文',
  'view-all-orders': 'すべての注文を表示',
  'email_registered': {
    'text1': '{email} はすでに登録されています。 ',
    'link': 'ログイン',
    'text2': ' して注文履歴をご確認ください。'
  },
  'country-region': '国',
  'select-country': '国を選択してください。',
  'preferred-language': 'ご返信の言語',
  'select-language': '言語を選択してください。',
  'next': '次へ',
  'encountered-error': 'エラーが発生しました。もう一度お試しください。',
  'your-enquiry': 'お問い合わせ',
  'nature-enquiry': 'お問い合わせタイプ',
  'order-number': '注文番号',
  'order-id': '注文番号',
  'for-amazon-order': '[参照]オンライン販売等でご注文の場合',
  'order-id-bak': 'Amazon注文ID',
  'for-amazon-order-bak': 'Amazonからのご注文の場合',
  'enter-order-number': '注文番号を入力してください。',
  'rma-number': 'RMA番号',
  'enter-rma-number': 'RMA番号を入力してください。',
  'purchase_creative_com': {
    'text': '製品がCreative.comからご購入の場合、 ',
    'link': 'こちらから交換リクエストをお申し込みください。'
  },
  'not-purchase-creative-com': '<p>Creative.com以外でご購入頂きました場合、返品リクエストについて小売店に直接お問い合わせください</p><p><a href="https://jp.creative.com/help/warranty-returns" target="_blank">保証と返品情報につきましては、ここをクリックしてご確認ください。</a></p>',
  'not-purchase-creative-com-retailer-replacement': 'Creative.comから直接ご購入ではなかった場合は、製品交換リクエストについてご購入いただきました販売店様にお問い合わせください。',
  'not_purchase_creative_com_2': {
    'text': '製品がCreative.comからご購入ではなかったの場合、',
    'link': 'こちらから交換リクエストをお申し込みください。'
  },
  'order-not-found': 'この注文番号はこのメールアドレスに属していません。もう一度お試しください。',
  'rma-not-found': 'ご入力頂きましたRMA番号は、弊社の記録にはありません。有効なRMA番号を入力してください。',
  'previous-order': '前のご注文',
  'next-order': '次のご注文',
  'add-your-product': '製品を追加する',
  'search-by-name': '製品名で検索',
  'select-product': '少なくとも1つの製品を選択してください。',
  'upload-proof-update-date': {
    'text1': 'ご購入証明書とご購入日をご提供ください。 <br/>ご購入証明書がない場合は、こちらから',
    'link': 'お問い合わせ',
    'text2': ' ください。'
  },
  'return-product': '製品を返品する',
  'return-products': '製品を返品する',
  'replace-defective-product': '不良品の交換',
  'check-rma-status': 'RMAステータスのご確認',
  'service-request': '利用可能なサービスリクエスト',
  'select-one-service': 'サービスリクエストを1つ選択してください。同じ注文に対して、複数のサービスリクエストが必要の場合は、問題ごとに異なるサービスリクエストをお申し込みください。(製品の保証期間外の場合は、以下より「不良品の交換」は選択できません。「お問い合わせ」を選択し、弊社カスタマーサポートへご相談ください。)',
  'select-one-servcie-2': 'サービスリクエストを1つ選択してください。',
  'refund-products': '返品/返金する',
  'qualifies-refund': ' {refundNotAvailable} のみが満足保証のもとで返品/返金の対象となります。<br />続行する前に製品を説明してください。',
  'replace-products': '不良品の交換',
  'qualifies-replace': ' {repairNotAvailable} のみが交換対象となります。 <br />「保証期間外の製品」に関しては、カスタマーサポートにご相談ください。 ',
  'contact-us-assistance': 'お問い合わせ',
  'return-information': '返品情報',
  'replacement-information': '交換情報',
  'fill-in-all': 'このセクションのすべてのフィールドに入力してください。',
  'message': 'メッセージ',
  'enter-message': 'メッセージを入力してください。',
  'submit': '提出',
  'submission-successful': 'リクエストが提出されました。',
  'contact-us-thank-you': '2営業日以内にご連絡いたします。',
  'back-to-home': 'ホームページに戻る',
  'confirmation': 'ご確認',
  'rma-confirmation': 'RMAのご確認',
  'refresh-page': 'リフレッシュ',
  'loading': '読み込み中...',
  'select': 'お届け先住所として選択',
  'selected': '選択済み',
  'update': 'お届け先住所を変更',
  'address': 'ご住所',
  'new-address': '新しいお届け先住所を追加する',
  'edit': '変更',
  'update-address': 'お届け先住所を更新',
  'cancel': 'キャンセル',
  'back': '戻る',
  'select-your-products': '製品を選択してください。',
  'serial-number': 'シリアル番号',
  'returns-eligibility': '返品/返金資格',
  'warranty': '保証期間',
  'proof-purchase': 'ご購入証明',
  'purchase-date': 'ご購入日',
  'select-date': '日付を選択する',
  'how-find-serial-num': 'シリアル番号の確認方法',
  'yes': 'あり',
  'no': 'なし',
  'choose-file': 'ファイルを選択する',
  'upload-supporting-file': 'サポート画像をアップロードする',
  'remove': '削除',
  'warranty-days-left': '残り{warrantyDaysRemain} 日',
  'out-warranty': '保証期間外',
  'enter-serial': 'シリアル番号を入力する',
  'enter-serial-number': '有効なシリアル番号を入力してください。',
  'serial-not-valid': '有効なシリアル番号を入力してください。',
  'serial-num-submitted': '有効なシリアル番号を入力してください。',
  'file-formats-allowed': 'ご利用可能なファイル形式: PDF, JPG, PNG, ZIP。 最大ファイルサイズ: 4MB。',
  'thank-you-rma-submit': 'RMAのご提出、大変ありがとうございました。',
  'provide-rma-number': 'このRMAについてお問い合わせの場合は、RMA番号が発行されている場合、カスタマーサポートチームにRMA番号をお知らせください。',
  'retrieve_rma_status': {
    'text': 'また、',
    'link': 'Creative Store アカウント\'に登録すれば、RMAステータスを確認したら、RMAに変更したりすることもできます。'
  },
  'product-details': '製品について',
  'product': '製品',
  'rma-details': 'RMAについて',
  'service-request2': 'サービスリクエスト',
  'refund': '返金',
  'replacement': '交換',
  'rma-status': 'RMAステータス',
  'expires-date': '有効期限 {date}',
  'refund-estimated-cost': '注意: 返金金額はあくまでも見積もりであり、変更される可能性があります。',
  'service-fee': '有償交換',
  'service-fee-text': 'ご送付頂いた製品が、お客様の瑕疵による故障や症状（お客様の過失による破損など）とご判断させて頂いた場合、また、非正規販売店、日本国外、 中古品のご購入等の場合など、有償対応となる場合がございます。  そうした場合は、メールにて御連絡申し上げます。',
  'product-is-defective': '不良品',
  'repair-status-list': [
    {
      status: 'RMAリクエスト（修理交換 お申し込み）を受領しました。',
      desc: '<p>RMAリクエスト（修理交換 お申し込み）は現在、確認、処理中です。</p>'
    },
    {
      status: 'RMA 確認済み',
      desc: `<p>製品をご送付ください。 <br /><i></i></p>
            <span style="font-weight: 500;">【重要】製品ご送付のお手続きに関するご案内</span>
            <div class="return-instruction">
              製品ご送付の際のお手続き方法に関しましては、Eメールにてご送付される <strong>「件名：クリエイティブメディア 修理交換お申し込みご確認のお知らせ」</strong> を必ずご確認ください。
              <br>
              <strong>
              ▲製品の「ご送付先の住所」に関しましては、同メールのみに記載されております。</strong><br />
              なお、合わせて、下記ページをご参照ください。（<a href="/support/warranty/rma/obtainrma.asp" target="obtainrma" style="text-decoration:underline">https://jp.creative.com/support/warranty/rma/obtainrma.asp</a>）</div>`
    },
    {
      status: '製品を受け取りました。',
      desc: `<p>ご連絡の症状がご確認できた場合において、通常約3〜5営業日程度を頂いております。（※症状が確認できない場合や詳細確認が必要、交換品のご用意等、お時間がかかる場合がございます。
            ご連絡の症状が確認できない場合やご確認事項がある場合等、カスタマーサポートよりメールにてご連絡をさせて頂く場合がございます。）</p>`,
    },
    {
      status: '製品のご確認中',
      desc: `<p>お預かり製品のご確認中です。
      （※症状が確認できない場合や詳細確認が必要、交換品のご用意等、お時間がかかる場合がございます。
      ご連絡の症状が確認できない場合やご確認事項がある場合等、カスタマーサポートよりメールにてご連絡をさせて頂く場合がございます。）</i></p>`,
    },
    {
      status: '発送の準備',
      desc: `<p>交換製品の発送準備中です。[▲お預かりの製品に問題がない場合は、お預かり製品のお戻し準備中となります。]<br />
           </p>`,
    },
    {
      status: '交換品の出荷済み',
      desc: '<p>交換製品が出荷されました。[▲お預かりの製品に問題がない場合は、お預かり製品のお戻し出荷となります。]  </p>',
    }
  ],
  'refund-status-list': [
    {
      status: 'RMAリクエストを受け取った',
      desc: '<p>RMAリクエストは現在処理中です。<br /><i>(通常1〜2営業日かかります。)</i></p>'
    },
    {
      status: 'RMA承認済み',
      desc: `<p>製品をご送付ください。 <br /><i>(通常1〜2営業日かかります。)</i></p>
              <span style="font-weight: 500;">製品送付のご案内</span>
              <div class="return-instruction">
                製品の送付お手続きについては、 (件名: Creative LabsのRMAリクエストが承認されました) を参照してください。
                <p style="margin:10px auto;{display_others}">配送ラベルは90日以内にダウンロードする必要があります。
                ラベルが一旦アクセスした場合は、5日以内にダウンロードまたは印刷する必要があります。 その後、アクセスするすることができません。
                ご注意ください。<br><a href="{courierLabelLink}" target="_blank" style="text-decoration:underline">配送ラベル</a></p>
              </div>`
    },
    {
      status: "製品を受け取った",
      desc: "<p>製品状況を確認中です。<br /><i>(通常1〜2営業日かかります。)</i></p>",
    },
    {
      status: "返金処理中",
      desc: "<p>製品の確認が完了です。<span style='{showAmount}'> の返金 <strong>{RefundAmtActual}</strong></span>を処理中です。<br /><i>(通常3〜5営業日かかります。)</i></p>",
    },
    {
      status: "返金完了",
      desc: "<p>元のお支払い方法への返金が完了しました。 銀行がリクエストを処理するのに最大30日かかる場合があります。 詳細については、銀行にお問い合わせください。</p><p><i>(銀行が返金の受け取りを処理するのに最大30日かかる場合があります。)</i></p>",
    }
  ],
  'what-are-reason': '返品の理由は何ですか？',
  'which-part-defective': '製品のどの部分が故障しましたか？',
  'please-select-one': '一つを選択してください。',
  'cosmetic-damages': '製品に物理的な破損はありますか？',
  'attach-photo': '破損の写真を添付する:',
  'comments': 'コメント',
  'enter-comments': '製品の症状をご説明ください。',
  'rma-exists': 'この製品のRMAリクエストが送信されました。',
  'rma-created': 'この製品のRMAリクエストはすでに存在しておりますので、再度作成することはできません。',
  'rma-cancelled': 'RMAリクエストはキャンセルされました。 RMAリクエストのキャンセルについてご不明な点がある場合は、サポートチームまでお問い合わせください。',
  'selected-maximum': '許可されている最大数量を選択しました。',
  'shipping-information': 'お届け先',
  'shipping-address': 'お届け先',
  'select-shipping-address': 'お届け先をご選択ください。',
  'replace-sent-address': '交換品は次の配送先住所にご送付します。 ',
  'product-purchased-from': '製品のご購入先',
  'creative-store': 'クリエイティブストア',
  'all-other-retailers': `その他の販売店. <br>
                        （「クリエイティブストア＠楽天市場店」、「Amazon CREATIVE STORE 」の場合もこちらを選択してください。）`,
  'product-not-received': '未着荷',
  'product-cancelled': 'キャンセル',
  'rma-closed': '閉じる',
  'select-mode-of-contact': 'ご連絡方法を選択してください。',
  'email-us': 'Eメールを送る',
  'your-order': 'ご注文',
  'refund-amount': '返金金額',
  'shipping-charge': '送料',
  'store-credit': 'ストアクレジット',
  'tax': '消費税 ',
  'comment-describe': '<strong>症状の詳細をご記載ください。</strong><br /> ▲なるべく詳細で具体的な症状や発生状況、発生頻度や再現性をご記載ください。<br />▲また、ご利用の再生機器(Windows PC、スマートフォン等)のメーカー、型番、OS、仕様やアプリケーション等に関しても詳細をご記載ください。<br />▲おわかりの場合は、カスタマーサポートにお問い合わせ頂いた際の「Case ID」もご記載ください。',
  'deliver-unable-info':'',
  'creative-in-warranty': `ご選択いただいたシリアル番号/ご注文番号の製品は、ご購入時に延長保証チケットを同時購入いただいておりますが、現在は弊社の保証期間中となりますので、このままお手続きを進めてください。延長保証の内容については、<a href="https://www.sompo-swt.com/join/plan.html" target="_blank" style="text-decoration: underline">こちら（SOMPOワランティ株式会社の「ご加入中のお客さま」）</a>をご確認ください。`,
  'extended-warranty': `ご選択いただいたシリアル番号/ご注文番号の製品は、現在延長保証の適用期間となっております。 延長保証期間中の保証対応につきましては、弊社の延長保証の運営会社であるSOMPOワランティ株式会社での対応となりますので、<a href="https://www.sompo-swt.com/join/repair.html" target="_blank" style="text-decoration:underline">こちらをご確認</a> うえお問合せ/お申込みをお願いいたします。`,
  'maintenance-msg': `お知らせ：
                      当社では2022年10月9日（日曜日）午前10:00 ～午後4:00の間、サーバーのメンテナンスを行います。
                      そのため、この間は当社のサイトにアクセスができなくなります。
                      <br><br>
                      大変ご迷惑をおかけいたしますが、よろしくお願いいたします。`,
  'shipping-country-notice-jp': ''
  }